import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function debounce(fn: Function, ms = 300) {
  let timeoutId: ReturnType<typeof setTimeout>
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.apply(this, args), ms)
  }
}

export function getDom(date: string | Date) {
  const hours = (new Date().getTime() - new Date(date).getTime()) / 1000 / 3600
  const days = Math.round(hours / 24)
  return days
}

export function valuesToValueLabelOptions(
  values: { [key: string]: any } | string[]
) {
  const options: { value: string; label: string }[] = []
  if (Array.isArray(values)) {
    values.forEach((value) => {
      options.push({ value, label: value })
    })
  } else {
    Object.keys(values).forEach((value) => {
      const label = values[value]
      options.push({ value, label })
    })
  }
  return options
}

export function tryParseJson(value: string) {
  try {
    return JSON.parse(value)
  } catch (error) {}
  return []
}
